/**
 * API client das fontes dos tribunais (área admin): URL do sistema processual e as duas habilitações de cada
 * fonte — conferência com o tribunal ao abrir os autos e peticionamento direto no sistema. Proxy para o
 * autenticador via backend. Ver docs/PLANO_SINCRONIZACAO_TRIBUNAL.md (§4.7).
 */
import { api } from './client';

export interface FonteTribunal {
  id_fonte: string;
  sistema_processual: string | null;
  instancia: string | null;
  tribunal_sigla: string | null;
  tribunal_jtr: string | null;
  url: string | null;
  consulta_nativa_habilitada: boolean;
  peticionamento_nativo_habilitado: boolean;
  /** A conferência sabe navegar neste sistema (família PJe). */
  consulta_nativa_suportada: boolean;
  tramitacoes: number;
  atualizado_em: string | null;
}

/** Campos ausentes não mudam; `url: ''` remove a URL. */
export interface AtualizarFonteTribunalInput {
  url?: string;
  consulta_nativa_habilitada?: boolean;
  peticionamento_nativo_habilitado?: boolean;
}

const BASE = '/admin/fontes-tribunais';

export async function fetchFontesTribunais(): Promise<FonteTribunal[]> {
  const { data } = await api.get<FonteTribunal[]>(BASE);
  return data;
}

export async function atualizarFonteTribunal(
  idFonte: string,
  input: AtualizarFonteTribunalInput,
): Promise<FonteTribunal> {
  const { data } = await api.patch<FonteTribunal>(`${BASE}/${encodeURIComponent(idFonte)}`, input);
  return data;
}
